<app-base-list-wrapper [baseListComponent]="this">
    <ng-template #moreButtons let-table>
        <div *ngIf="showAddEInvoiceDetails()" class="flex items-center gap-2">
            <p-button
                outlined="true"
                label="{{ 'address.add-electronic-invoice-details' | translate }}"
                (click)="addEInvoiceDetails()"
                data-testid="add-e-invoice-details"
                icon="fa-solid fa-plus"
                styleClass="animate-fadein"
                [loading]="showAddEInvoiceDetailsButtonLoading()"
            ></p-button>
            <div class="italic [--p-message-info-simple-color:var(--p-text-muted-color)]">
                <p-message
                    severity="info"
                    variant="simple"
                    size="small"
                    icon="fa fa-info-circle"
                    data-testid="add-e-invoice-details-hint"
                >{{ 'address.add-electronic-invoice-details-hint' | translate }}</p-message>
            </div>
        </div>
    </ng-template>
</app-base-list-wrapper>
